export const SlideTileWrapper =
  'flex flex-col shrink-0 grow-0 w-full lg:w-1/3 min-h-[300px] lg:min-h-[676px] overflow-hidden lg:px-2 xl:px-6'

export const SlideHeadWrapper =
  'flex flex-col w-full relative justify-end text-white h-[300px] lg:h-[676px]'

export const SlideImageWrapper =
  'flex w-full min-h-[300px] h-[300px] lg:min-h-[360px] lg:h-auto object-cover'

export const SlideImage = 'mx-auto w-full object-cover'

export const SlideContentDarkWrapper = 'flex flex-col px-3 pt-4 md:py-8'

export const SlideContentWrapper =
  'flex flex-col px-3 pt-4 md:py-8 lg::h-full lg:min-h-[250px]'

export const SlideTextContentWrapper =
  'lg:flex flex-col shrink-0 grow-0 justify-center w-full text-white h-40 lg:h-[316px] pl-4 xl:pl-[80px] reco-xxl:pl-[120px]'

export const SlideTopRegionRichText =
  'text-36 lg:text-44 leading-48 lg:leading-56 tracking-0 lg:tracking-0 pb-6 md:pb-0'

export const SlideBottomRegionRichText = 'text-14 leading-24 tracking-0 w-full'

export const SlideCTAButton = 'm-3 w-full md:w-auto'

export const SliderTextStyle = {
  dark: 'text-white',
  light: 'text-black'
}
